import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { setAnalysis, setBrokerReminder, setCan, setCargoAndQuantity, setChartererBrokerContactPrinciple, setChartererBrokerPrinciples, setCheckLists, setDelivery, setDemDetention, setDisportInfo, setEnableValidation, setFreightRate, setHire, setHireRate, setILOHCAndCVE, setInvoiceInput, setLay, setLoadDisrate, setLoadportInfo, setMinMaxPeriodTill, setNote, setOwnerBrokerContactPrinciple, setOwnerBrokerPrinciples, setPaymentNote, setRange, setRedelivery, setStatus, SupportSheetSelector, SupportSheetState } from './reducers/SupportSheetReducer';
import CustomAccordion from '../CustomAccordion/CustomAccordion';
import { Autocomplete, AutocompleteChangeDetails, Button, Checkbox, Grid, TextField } from '@mui/material';
import Utility from '../../app/utility';
import StartEndDatepicker from '../StartEndDatepicker/StartEndDatepicker';
import { CheckList, CheckListHistoryItem, SupportSheetStatus } from './models/SupportSheetModel';
import { setFixturePreviewModel, setShowPreviewPanel } from '../FixtureManagement/reducers/FixturePreviewReducer';
import { MarketInfoType } from '../MarketInfo/models/MarketInfoQueryModel';
import SupportSheetPrinciple from './components/SupportSheetPrinciple/SupportSheetPrinciple';
import SupportSheetInvoice, { getDefaultInvoices, SupportSheetInvoiceInputProp } from './components/SupportSheetInvoice/SupportSheetInvoice';
import SupportSheetAnalysis, { getDefaultAnalysis } from './components/SupportSheetAnalysis/SupportSheetAnalysis';
import SupportSheetAnalysisModel from './components/SupportSheetAnalysis/models/SupportSheetAnalysisModel';
import SupportSheetInvoiceModel from './components/SupportSheetInvoice/models/SupportSheetInvoiceModel';
import CompanyNamePICModel from '../CompanyNamePIC/models/CompanyNamePICModel';
import EmailEditorModel from '../EmailEditorModal/models/EmailEditorModel';
import { SupportSheetCheckListConstant } from './models/SupportSheetCheckListConstant';
import { PopupEmail } from './SupportSheetPreVoyage';
import CommissionItemModel from '../FixtureManagement/components/FixtureCommissionDetail/models/CommissionItemModel';

export const contructEmailSubjectPrefix = (supportSheetData: SupportSheetState) => {
    let companyName = supportSheetData.chartererBrokerContactPrinciple?.companyName;
    return `MV. ${supportSheetData.currentFixture.tonnageVesselName} / ${companyName} C/P: ${Utility.DateFormat.formatDateStringFullYear(supportSheetData.currentFixture.cpDate)} - `.toUpperCase();
}

export const hasError = (enableValidation: boolean, value: string | null, isDontFollowShipment: boolean = false): boolean => {
    if (isDontFollowShipment) {
        return false;
    }

    return enableValidation && (value == undefined ||
        value == null ||
        value.length == 0);
}


export const hasErrorNumber = (enableValidation: boolean, value: number | null, isDontFollowShipment: boolean = false) => {
    if (isDontFollowShipment) {
        return false;
    }

    return enableValidation && (value == undefined ||
        value == null ||
        value == 0);
}

export const getErrorClass = (enableValidation: boolean, value: string | null, isDontFollowShipment: boolean = false) => {
    return hasError(enableValidation, value, isDontFollowShipment) ? " support-sheet-red-text-error" : "";
}

export const getErrorNumberClass = (enableValidation: boolean, value: number | null, isDontFollowShipment: boolean = false) => {
    return hasErrorNumber(enableValidation, value, isDontFollowShipment) ? " support-sheet-red-text-error" : "";
}

const SupportSheetBiefInformation: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const supportSheetData = useSelector(SupportSheetSelector);

    const isDontFollowShipment = () => {
        return supportSheetData.model.checkLists ? supportSheetData.model.checkLists.indexOf(SupportSheetCheckListConstant['We dont follow this shipment']) > -1 : false;
    }

    const validateCloseFile = () => {
        return document.getElementsByClassName("support-sheet-red-text-error").length === 0
    }

    const getContactErrorClass = (enableValidation: boolean, value: CompanyNamePICModel | null, isDontFollowShipment: boolean = false) => {
        if (isDontFollowShipment) {
            return "email-disable";
        }

        if (enableValidation && value == null) {
            return "support-sheet-contact-error support-sheet-red-text-error";
        }
    }

    const updateCheckList = (checkListName: string, isAdded: boolean) => {
        let checkList = supportSheetData.model.checkLists ? JSON.parse(supportSheetData.model.checkLists) as CheckList :
            {
                checkListItems: [],
                history: []
            } as CheckList;

        if (isAdded) {
            checkList.checkListItems.push(checkListName);

            //history
            let index = _.findIndex(checkList.history, (item) => {
                return item.name === checkListName;
            });

            if (index === -1) {
                checkList.history.push({
                    name: checkListName.replace(".", ""),
                    date: new Date().toISOString()
                } as CheckListHistoryItem)
            }
        } else {
            let removeIndex = _.indexOf(checkList.checkListItems, checkListName);
            checkList.checkListItems.splice(removeIndex, 1);
        }

        dispatch(setCheckLists(JSON.stringify(checkList)));
    }

    const getCommRateDetail = () => {
        let commDetails = JSON.parse(supportSheetData.currentFixture.commRateDetail) as CommissionItemModel[];

        let commRateDetail = "";
        _.each(commDetails, (commItem) => {
            commRateDetail += commItem.brokerName + commItem.percent + " ";
        })

        return commRateDetail;
    }

    const getCompanyNamePICPreview = (companyNamePIC: CompanyNamePICModel | null) => {
        if (companyNamePIC) {
            return companyNamePIC.companyName + " - " + companyNamePIC.pic;
        }
        return "";
    }

    return (
        <>
            <CustomAccordion
                title="Brief Information"
                defaultOpen={true}
                open={true}
                onOpenChange={(isOpen: boolean) => {
                }}
            >
                <Grid container>
                    <Grid item xs={6}>
                        <Grid container>
                            <Grid item xs={6}>
                                Ref no:
                            </Grid>
                            <Grid item xs={6}>
                                {supportSheetData.currentFixture.ref}
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={6}>
                        <Button
                            variant="outlined"
                            onClick={() => {
                                dispatch(setFixturePreviewModel(supportSheetData.currentFixture));
                                dispatch(setShowPreviewPanel(true));
                            }}
                        >Handover</Button>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={6}>
                        <Grid container>
                            <Grid item xs={6}>
                                Supporter:
                            </Grid>
                            <Grid item xs={6}>
                                {supportSheetData.currentFixture.supportName}
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={6}>
                        <Grid container>
                            <Grid item xs={6}>
                                Cp dated:
                            </Grid>
                            <Grid item xs={6}>
                                {Utility.DateFormat.formatDateString(supportSheetData.currentFixture.cpDate)}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={3}>
                        Brokers:
                    </Grid>
                    <Grid item xs={9}>
                        {getCommRateDetail()}
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={6} className={(isDontFollowShipment() ? "email-disable" : "")}>
                        Owner's/Brkr's contact
                    </Grid>
                    <Grid item xs={6} className={(isDontFollowShipment() ? "email-disable" : "")}>
                        Chtr's/Brker's contact
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={6}>
                        <Grid container>
                            <Grid item lg={9}>
                                <div className={getContactErrorClass(supportSheetData.enableValidation, supportSheetData.ownerBrokerContactPrinciple, isDontFollowShipment())}>
                                    {getCompanyNamePICPreview(supportSheetData.ownerBrokerContactPrinciple)}
                                </div>
                            </Grid>
                            <Grid item lg={3}>
                                <SupportSheetPrinciple
                                    selectedPrincipleId={supportSheetData.model.ownerBrokerPrincipleId}
                                    disabled={isDontFollowShipment()}
                                    onChange={(selectedId: string, selectedItem: CompanyNamePICModel | null) => {
                                        dispatch(setOwnerBrokerPrinciples(selectedId));
                                        dispatch(setOwnerBrokerContactPrinciple(selectedItem));
                                    }}
                                >
                                </SupportSheetPrinciple>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={6}>
                        <Grid container>
                            <Grid item lg={9}>
                                <div className={getContactErrorClass(supportSheetData.enableValidation, supportSheetData.chartererBrokerContactPrinciple, isDontFollowShipment())}>
                                    {getCompanyNamePICPreview(supportSheetData.chartererBrokerContactPrinciple)}
                                </div>
                            </Grid>
                            <Grid item lg={3}>
                                <SupportSheetPrinciple
                                    selectedPrincipleId={supportSheetData.model.chartererBrokerPrincipleId}
                                    disabled={isDontFollowShipment()}
                                    onChange={(selectedId: string, selectedItem: CompanyNamePICModel | null) => {
                                        dispatch(setChartererBrokerPrinciples(selectedId));
                                        dispatch(setChartererBrokerContactPrinciple(selectedItem));
                                    }}
                                >
                                </SupportSheetPrinciple>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={6} className={(isDontFollowShipment() ? "email-disable" : "")}>
                        MV. {supportSheetData.currentFixture.tonnageVesselName}
                    </Grid>
                    <Grid item xs={6}>
                    </Grid>
                </Grid>
                {
                    (supportSheetData.currentFixture.bizType == MarketInfoType.Voy || supportSheetData.currentFixture.bizType == MarketInfoType.COA) &&
                    <>
                        <TextField
                            label="Cargo & qtt"
                            fullWidth
                            disabled={isDontFollowShipment()}
                            value={supportSheetData.model.cargoAndQuantity}
                            onChange={(event) => {
                                dispatch(setCargoAndQuantity(event.target.value));
                            }}
                            error={
                                hasError(supportSheetData.enableValidation, supportSheetData.model.cargoAndQuantity, isDontFollowShipment())
                            }
                            className={'cargo-input-component' + getErrorClass(supportSheetData.enableValidation, supportSheetData.model.cargoAndQuantity, isDontFollowShipment())}
                        />
                        <TextField
                            label="Freight rate"
                            fullWidth
                            disabled={isDontFollowShipment()}
                            value={supportSheetData.model.freightRate}
                            onChange={(event) => {
                                dispatch(setFreightRate(event.target.value));
                            }}
                            error={
                                hasError(supportSheetData.enableValidation, supportSheetData.model.freightRate, isDontFollowShipment())
                            }
                            className={'cargo-input-component' + getErrorClass(supportSheetData.enableValidation, supportSheetData.model.freightRate, isDontFollowShipment())}
                        />
                        <Grid container>
                            <Grid item xs={10}>
                                <StartEndDatepicker
                                    startDateLabel="Lay"
                                    endDateLabel="Can"
                                    disabled={isDontFollowShipment()}
                                    useQuickEndDateInput={false}
                                    onStartDateChange={(date: string) => {
                                        dispatch(setLay(date));
                                    }}
                                    onEndDateChange={(date: string) => {
                                        dispatch(setCan(date));
                                    }}
                                    startDateValue={supportSheetData.model.lay ? supportSheetData.model.lay.toUpperCase() : ""}
                                    endDateValue={supportSheetData.model.can ? supportSheetData.model.can.toUpperCase() : ""}
                                    allowFreeInput={true}
                                    customFormatDate={(date: Date) => {
                                        return Utility.DateFormat.formatDDMMMYYhhss(date).toUpperCase();
                                    }}
                                    startDateError={
                                        hasError(supportSheetData.enableValidation, supportSheetData.model.lay, isDontFollowShipment())
                                    }
                                    endDateError={
                                        hasError(supportSheetData.enableValidation, supportSheetData.model.can, isDontFollowShipment())
                                    }
                                    className={'cargo-input-component' + getErrorClass(supportSheetData.enableValidation, supportSheetData.model.lay, isDontFollowShipment())
                                        + getErrorClass(supportSheetData.enableValidation, supportSheetData.model.can, isDontFollowShipment())}
                                >
                                </StartEndDatepicker>
                            </Grid>
                            <Grid item xs={2}>
                                <Checkbox
                                    checked={supportSheetData.model.brokerReminder}
                                    disabled={isDontFollowShipment()}
                                    onChange={(event) => {
                                        dispatch(setBrokerReminder(event.target.checked));
                                    }}
                                />
                            </Grid>
                        </Grid>
                        <TextField
                            label="Loadport"
                            fullWidth
                            disabled={isDontFollowShipment()}
                            value={supportSheetData.model.loadportInfo}
                            onChange={(event) => {
                                dispatch(setLoadportInfo(event.target.value));
                            }}
                            error={
                                hasError(supportSheetData.enableValidation, supportSheetData.model.loadportInfo, isDontFollowShipment())
                            }
                            className={'cargo-input-component' + getErrorClass(supportSheetData.enableValidation, supportSheetData.model.loadportInfo, isDontFollowShipment())}
                        />
                        <TextField
                            label="Disport"
                            fullWidth
                            disabled={isDontFollowShipment()}
                            value={supportSheetData.model.disportInfo}
                            onChange={(event) => {
                                dispatch(setDisportInfo(event.target.value));
                            }}
                            error={
                                hasError(supportSheetData.enableValidation, supportSheetData.model.disportInfo, isDontFollowShipment())
                            }
                            className={'cargo-input-component' + getErrorClass(supportSheetData.enableValidation, supportSheetData.model.disportInfo, isDontFollowShipment())}
                        />
                        <TextField
                            label="Load/disrate"
                            fullWidth
                            disabled={isDontFollowShipment()}
                            value={supportSheetData.model.loadDisrate}
                            onChange={(event) => {
                                dispatch(setLoadDisrate(event.target.value));
                            }}
                            error={
                                hasError(supportSheetData.enableValidation, supportSheetData.model.loadDisrate, isDontFollowShipment())
                            }
                            className={'cargo-input-component' + getErrorClass(supportSheetData.enableValidation, supportSheetData.model.loadDisrate, isDontFollowShipment())}
                        />
                        <TextField
                            label="Dem/Detention"
                            fullWidth
                            disabled={isDontFollowShipment()}
                            value={supportSheetData.model.demDetention}
                            onChange={(event) => {
                                dispatch(setDemDetention(event.target.value));
                            }}
                            error={
                                hasError(supportSheetData.enableValidation, supportSheetData.model.demDetention, isDontFollowShipment())
                            }
                            className={'cargo-input-component' + getErrorClass(supportSheetData.enableValidation, supportSheetData.model.demDetention, isDontFollowShipment())}
                        />
                        <TextField
                            label="Payment"
                            rows={2}
                            multiline
                            fullWidth
                            disabled={isDontFollowShipment()}
                            value={supportSheetData.model.paymentNote}
                            onChange={(event) => {
                                dispatch(setPaymentNote(event.target.value));
                            }}
                            error={
                                hasError(supportSheetData.enableValidation, supportSheetData.model.paymentNote, isDontFollowShipment())
                            }
                            className={'cargo-input-component tonnage-input-full-tc' + getErrorClass(supportSheetData.enableValidation, supportSheetData.model.paymentNote, isDontFollowShipment())}
                        />
                    </>
                }
                {
                    (supportSheetData.currentFixture.bizType == MarketInfoType.TCT || supportSheetData.currentFixture.bizType == MarketInfoType.TC) &&
                    <>
                        <Grid container>
                            <Grid item xs={10}>
                                <StartEndDatepicker
                                    startDateLabel="Lay"
                                    endDateLabel="Can"
                                    disabled={isDontFollowShipment()}
                                    useQuickEndDateInput={false}
                                    onStartDateChange={(date: string) => {
                                        dispatch(setLay(date));
                                    }}
                                    onEndDateChange={(date: string) => {
                                        dispatch(setCan(date));
                                    }}
                                    startDateValue={supportSheetData.model.lay.toUpperCase()}
                                    endDateValue={supportSheetData.model.can.toUpperCase()}
                                    allowFreeInput={true}
                                    customFormatDate={(date: Date) => {
                                        return Utility.DateFormat.formatDDMMMYYhhss(date).toUpperCase();
                                    }}
                                    startDateError={
                                        hasError(supportSheetData.enableValidation, supportSheetData.model.lay, isDontFollowShipment())
                                    }
                                    endDateError={
                                        hasError(supportSheetData.enableValidation, supportSheetData.model.can, isDontFollowShipment())
                                    }
                                    className={'cargo-input-component' + getErrorClass(supportSheetData.enableValidation, supportSheetData.model.lay, isDontFollowShipment())
                                        + getErrorClass(supportSheetData.enableValidation, supportSheetData.model.can, isDontFollowShipment())}
                                >
                                </StartEndDatepicker>
                            </Grid>
                            <Grid item xs={2}>
                                <Checkbox
                                    checked={supportSheetData.model.brokerReminder}
                                    disabled={isDontFollowShipment()}
                                    onChange={(event) => {
                                        dispatch(setBrokerReminder(event.target.checked));
                                    }}
                                />
                            </Grid>
                        </Grid>
                        <TextField
                            label="Hire rate"
                            fullWidth
                            disabled={isDontFollowShipment()}
                            value={supportSheetData.model.hireRate ? supportSheetData.model.hireRate : ""}
                            onChange={(event) => {
                                dispatch(setHireRate(event.target.value));
                            }}
                            error={
                                hasError(supportSheetData.enableValidation, supportSheetData.model.hireRate, isDontFollowShipment())
                            }
                            className={'cargo-input-component' + getErrorClass(supportSheetData.enableValidation, supportSheetData.model.hireRate, isDontFollowShipment())}
                        />
                        <TextField
                            label="Hire"
                            fullWidth
                            disabled={isDontFollowShipment()}
                            value={supportSheetData.model.hire ? supportSheetData.model.hire : ""}
                            onChange={(event) => {
                                dispatch(setHire(event.target.value));
                            }}
                            error={
                                hasError(supportSheetData.enableValidation, supportSheetData.model.hire, isDontFollowShipment())
                            }
                            className={'cargo-input-component' + getErrorClass(supportSheetData.enableValidation, supportSheetData.model.hire, isDontFollowShipment())}
                        />
                        <TextField
                            label="Delivery"
                            fullWidth
                            disabled={isDontFollowShipment()}
                            value={supportSheetData.model.delivery ? supportSheetData.model.delivery : ""}
                            onChange={(event) => {
                                dispatch(setDelivery(event.target.value));
                            }}
                            error={
                                hasError(supportSheetData.enableValidation, supportSheetData.model.delivery, isDontFollowShipment())
                            }
                            className={'cargo-input-component' + getErrorClass(supportSheetData.enableValidation, supportSheetData.model.delivery, isDontFollowShipment())}
                        />
                        <TextField
                            label="Redelivery"
                            fullWidth
                            disabled={isDontFollowShipment()}
                            value={supportSheetData.model.redelivery ? supportSheetData.model.redelivery : ""}
                            onChange={(event) => {
                                dispatch(setRedelivery(event.target.value));
                            }}
                            error={
                                hasError(supportSheetData.enableValidation, supportSheetData.model.redelivery, isDontFollowShipment())
                            }
                            className={'cargo-input-component' + getErrorClass(supportSheetData.enableValidation, supportSheetData.model.redelivery, isDontFollowShipment())}
                        />
                        <TextField
                            label="Trading Limitation"
                            fullWidth
                            disabled={isDontFollowShipment()}
                            value={supportSheetData.model.range ? supportSheetData.model.range : ""}
                            onChange={(event) => {
                                dispatch(setRange(event.target.value));
                            }}
                            error={
                                hasError(supportSheetData.enableValidation, supportSheetData.model.range, isDontFollowShipment())
                            }
                            className={'cargo-input-component' + getErrorClass(supportSheetData.enableValidation, supportSheetData.model.range, isDontFollowShipment())}
                        />
                        <TextField
                            label="ILOHC & CVE"
                            fullWidth
                            disabled={isDontFollowShipment()}
                            value={supportSheetData.model.ilohcandCve ? supportSheetData.model.ilohcandCve : ""}
                            onChange={(event) => {
                                dispatch(setILOHCAndCVE(event.target.value));
                            }}
                            error={
                                hasError(supportSheetData.enableValidation, supportSheetData.model.ilohcandCve, isDontFollowShipment())
                            }
                            className={'cargo-input-component' + getErrorClass(supportSheetData.enableValidation, supportSheetData.model.ilohcandCve, isDontFollowShipment())}
                        />
                        <StartEndDatepicker
                            startDateLabel="Min/Max Period Till"
                            useSingleMode={true}
                            useQuickEndDateInput={false}
                            disabled={isDontFollowShipment()}
                            onStartDateChange={(date: string) => {
                                dispatch(setMinMaxPeriodTill(date));
                            }}
                            startDateValue={Utility.DateFormat.formatDDMMMYYhhssString(supportSheetData.model.minMaxPeriodTill).toUpperCase()}
                            allowFreeInput={true}
                            startDateError={
                                hasError(supportSheetData.enableValidation, supportSheetData.model.minMaxPeriodTill, isDontFollowShipment())
                            }
                            className={'cargo-input-component' + getErrorClass(supportSheetData.enableValidation, supportSheetData.model.minMaxPeriodTill, isDontFollowShipment())}
                        >
                        </StartEndDatepicker>
                    </>
                }
                {
                    (supportSheetData.currentFixture.bizType == MarketInfoType.Voy || supportSheetData.currentFixture.bizType == MarketInfoType.COA) &&
                    <Autocomplete
                        className='cargo-input-component'
                        disableClearable={true}
                        color={'primary'}
                        options={[
                            SupportSheetStatus.PreArrivalLoadPort,
                            SupportSheetStatus.OnVoyage,
                            SupportSheetStatus.PendingLayTimeLTC,
                            SupportSheetStatus.PendingCommission,
                            SupportSheetStatus.CloseFile,
                            SupportSheetStatus.Cancel,
                            SupportSheetStatus.PendingDisputes,
                        ]}
                        renderInput={(params) => <TextField {...params} label="Status" />}
                        value={supportSheetData.model.status}
                        onChange={(event: React.SyntheticEvent, value: SupportSheetStatus, reason: string, details?: AutocompleteChangeDetails<SupportSheetStatus> | undefined) => {
                            if (value === SupportSheetStatus.CloseFile) {
                                dispatch(setEnableValidation(true));
                                setTimeout(() => {
                                    if (validateCloseFile()) {
                                        dispatch(setStatus(value));
                                        updateCheckList(SupportSheetCheckListConstant['Confirm close file'], true);
                                        Utility.Alert.Success("CONGRATULATIONS, YOU HAVE COMPLETED ONE MORE FITURE. GOOD JOB!")
                                    }
                                }, 1000);
                            } else {
                                dispatch(setStatus(value));
                            }

                        }}
                    />
                }
                {
                    (supportSheetData.currentFixture.bizType == MarketInfoType.TCT || supportSheetData.currentFixture.bizType == MarketInfoType.TC) &&
                    <Autocomplete
                        className='cargo-input-component'
                        disableClearable={true}
                        color={'primary'}
                        options={[
                            SupportSheetStatus.PreDelivery,
                            SupportSheetStatus.Delivered,
                            SupportSheetStatus.PendingFhs,
                            SupportSheetStatus.PendingCommission,
                            SupportSheetStatus.CloseFile,
                            SupportSheetStatus.Cancel,
                            SupportSheetStatus.PendingDisputes,
                        ]}
                        renderInput={(params) => <TextField {...params} label="Status" />}
                        value={supportSheetData.model.status}
                        onChange={(event: React.SyntheticEvent, value: SupportSheetStatus, reason: string, details?: AutocompleteChangeDetails<SupportSheetStatus> | undefined) => {
                            if (value === SupportSheetStatus.CloseFile) {
                                dispatch(setEnableValidation(true));
                                setTimeout(() => {
                                    if (validateCloseFile()) {
                                        dispatch(setStatus(value));
                                        updateCheckList(SupportSheetCheckListConstant['Confirm close file'], true);
                                        Utility.Alert.Success("CONGRATULATIONS, YOU HAVE COMPLETED ONE MORE FITURE. GOOD JOB!")
                                    }
                                }, 1000);
                            } else {
                                dispatch(setStatus(value));
                            }
                        }}
                    />
                }

                <Grid container
                    className='cargo-input-component'
                >
                    <Grid item xs={6}>
                        <Button
                            fullWidth
                            variant="outlined"
                            onClick={() => {
                                if (supportSheetData.ownerBrokerContactPrinciple) {
                                    PopupEmail({
                                        emailTo: supportSheetData.ownerBrokerContactPrinciple?.emailTo,
                                        emailCc: supportSheetData.ownerBrokerContactPrinciple?.emailCc,
                                        emailSubject: contructEmailSubjectPrefix(supportSheetData),
                                        emailContent: ``,
                                        receivedName: supportSheetData.ownerBrokerContactPrinciple?.pic
                                    } as EmailEditorModel, supportSheetData.brokerEmails);
                                } else {
                                    Utility.Alert.Error("Please select owner principle before sending email");
                                }
                            }}
                        >Send email to owners</Button>
                    </Grid>
                    <Grid item xs={6}>
                        <Button
                            fullWidth
                            variant="outlined"
                            onClick={() => {
                                if (supportSheetData.chartererBrokerContactPrinciple) {
                                    PopupEmail({
                                        emailTo: supportSheetData.chartererBrokerContactPrinciple?.emailTo,
                                        emailCc: supportSheetData.chartererBrokerContactPrinciple?.emailCc,
                                        emailSubject: contructEmailSubjectPrefix(supportSheetData),
                                        emailContent: ``,
                                        receivedName: supportSheetData.chartererBrokerContactPrinciple?.pic
                                    } as EmailEditorModel, supportSheetData.brokerEmails);
                                } else {
                                    Utility.Alert.Error("Please select charterer principle before sending email");
                                }
                            }}
                        >Send email to Charterers</Button>
                    </Grid>
                </Grid>
                <TextField
                    label="Notes"
                    multiline
                    fullWidth
                    rows={2}
                    color='secondary'
                    value={supportSheetData.model.note}
                    focused
                    onChange={(event) => {
                        dispatch(setNote(event.target.value));
                    }}
                    className="tonnage-input-full-tc"
                />
                <SupportSheetInvoice
                    input={{
                        collectCommFrom: supportSheetData.model.collectCommFrom,
                        coBrk: supportSheetData.model.invoiceCoBrk,
                        ours: supportSheetData.model.invoiceOurs,
                        total: supportSheetData.model.invoiceTotal,
                        commTerm: supportSheetData.model.commTerm
                    } as SupportSheetInvoiceInputProp}
                    onInputChange={(input: SupportSheetInvoiceInputProp) => {
                        dispatch(setInvoiceInput(input));
                    }}
                    viewMode={true}
                    type={supportSheetData.currentFixture.bizType}
                    selectedItems={!supportSheetData.model.invoices || supportSheetData.model.invoices.length == 0 ? getDefaultInvoices() : JSON.parse(supportSheetData.model.invoices) as SupportSheetInvoiceModel[]}
                ></SupportSheetInvoice>
                <SupportSheetAnalysis
                    item={!supportSheetData.model.analysis || supportSheetData.model.analysis.length == 0 ? getDefaultAnalysis() : JSON.parse(supportSheetData.model.analysis) as SupportSheetAnalysisModel}
                    onChange={(selectedItem: SupportSheetAnalysisModel) => {
                        dispatch(setAnalysis(JSON.stringify(selectedItem)));
                    }}
                    initialComplexity={supportSheetData.currentFixture.initEvaComplex}
                    initialVolume={supportSheetData.currentFixture.initEvaVolume}
                >
                </SupportSheetAnalysis>
            </CustomAccordion >
        </>
    )
};

export default SupportSheetBiefInformation;